import { ClientType, PeerIdType, PeerMessage, PeerMessageType, PresenceMessageType, websocket } from '@playcastdotio/Messaging';
import { getStateStore } from '../../../stores';
import { sendMessage as hostRealTime } from '../../realtime';
import { remoteHostHandlePeerMessage } from '../../peers/remoteControl';
import { USE_SESSION_COORDINATOR, USE_MEDIA_COORDINATOR } from '../../../../config/featureFlags';
import { peerCoordinator, realtimeSignalingService } from '../../../../coordinators/init';

const memoryStorage = new Map<PeerIdType, { peerId: string; peerToken?: string }>();

// Add a function to store peer data for reconnection
const storePeerData = (peerIdType: PeerIdType, peerId: string, peerToken?: string) => {
  // Disable localStorage for now
  return memoryStorage.set(peerIdType, { peerId, peerToken });
  // Store peer data in localStorage for persistence across sessions
  // if (peerToken) {
  //   const storageKey = `playcast_peerdata_${peerIdType}`;
  //   try {
  //     const peerData = { peerId, peerToken, peerIdType };
  //     localStorage.setItem(storageKey, JSON.stringify(peerData));
  //     console.log(`[RemoteHost] Stored peer data for ${peerIdType}`, {
  //       peerId,
  //       tokenPreview: peerToken.substring(0, 5) + '...',
  //     });
  //   } catch (e) {
  //     console.error(`[RemoteHost] Failed to store peer data for ${peerIdType}:`, e);
  //   }
  // }
};

// Function to retrieve stored peer data
export const getStoredPeerData = (peerIdType: PeerIdType): { peerId: string; peerToken?: string } | null => {
  // Disable localStorage for now
  return memoryStorage.get(peerIdType) || null;
  // const storageKey = `playcast_peerdata_${peerIdType}`;
  // try {
  //   const data = localStorage.getItem(storageKey);
  //   if (data) {
  //     const parsedData = JSON.parse(data);
  //     console.log(`[RemoteHost] Retrieved stored peer data for ${peerIdType}:`, {
  //       peerId: parsedData.peerId,
  //       hasToken: !!parsedData.peerToken,
  //     });
  //     return parsedData;
  //   }
  // } catch (e) {
  //   console.error(`[RemoteHost] Failed to parse stored peer data for ${peerIdType}`, e);
  // }
  // return null;
};

export const handlePeerMessage = (message: PeerMessage) => {
  console.log('Peer message:', message);
  switch (message.type) {
    case PeerMessageType.PEER_GET_ID_ANSWER: {
      console.log('Peer get id answer:', message);
      console.log('Peer get id answer with token?', !!message.peerToken);

      const target = message.peerIdType;
      const state = getStateStore('ipc');
      const hostPresence = state.hostPresenceState.currentState;

      // Store peer ID and token for reconnection
      if (message.peerToken) {
        console.log('Storing token for peer:', message.peerId, message.peerToken.substring(0, 5) + '...');
        storePeerData(message.peerIdType, message.peerId, message.peerToken);
      } else {
        console.warn('No token received for peer ID:', message.peerId);
      }

      if (message.iceServers) {
        console.log('Storing ice servers for peer:', message.peerId, message.iceServers);
        state.iceServerState.updateState({
          ...state.iceServerState.currentState,
          remoteHostIceServers: message.iceServers,
        });
      }

      switch (target) {
        case PeerIdType.HOST: {
          console.log('Host peer id:', message.peerId);
          hostPresence.hostPeerId = message.peerId;

          // STRANGLER-FIG: Bridge to PeerCoordinator
          if (USE_MEDIA_COORDINATOR) {
            peerCoordinator.updateHostPeerId(message.peerId);
          }
          break;
        }
        case PeerIdType.REMOTE_HOST: {
          console.log('Remote host peer id:', message.peerId);
          hostPresence.remoteHostPeerId = message.peerId;

          // STRANGLER-FIG: Bridge to PeerCoordinator
          if (USE_MEDIA_COORDINATOR) {
            peerCoordinator.updateRemoteHostPeerId(message.peerId);
          }
          break;
        }
        case PeerIdType.PLAYER:
        case PeerIdType.REMOTE_CLIENT: {
          console.log('Got peer id for player or remote client???', message);
          break;
        }
        default: {
          console.log('Unknown peer id target:', message);
          break;
        }
      }
      console.log('Updated host presence:', hostPresence);
      // update state
      state.hostPresenceState.updateState({ ...hostPresence });

      // STRANGLER-FIG: Skip PRESENCE_UPDATE when SessionCoordinator is active
      if (!USE_SESSION_COORDINATOR) {
        hostRealTime(
          websocket.generators.presence(PresenceMessageType.PRESENCE_UPDATE, {
            clientType: ClientType.HOST,
            presence: hostPresence,
          }),
        );
      }

      break;
    }
    case PeerMessageType.PEER_ICE_CANDIDATE:
    case PeerMessageType.PEER_SDP_ANSWER:
    case PeerMessageType.PEER_SDP_OFFER: {
      realtimeSignalingService.forwardValidated(message, remoteHostHandlePeerMessage);
      break;
    }
    case PeerMessageType.PEER_ERROR:
    case PeerMessageType.PEER_GET_ID:
    case PeerMessageType.PEER_ICE_COMPLETE:
    case PeerMessageType.PEER_STATS:
    case PeerMessageType.PEER_STATS_SUCCESS: {
      // Unwanted messages
      console.log('Unwanted peer message:', message);
      break;
    }
  }
};
